import SolarCalculator from './SolarCalculator';
export { SolarCalculator as default };
